﻿import {closeFilterList, peek, search} from "./overview-filters";
import {setMultiChoiceFromParams} from "./overview-filter-multichoice";
import {setNumbersFromParams} from "./overview-filter-value";
import { loadFromUrl } from "./overview-filter-state";
import { attributes } from "./overview-filter-constants";

export const popups = {
	jobField: "JobField",
	educationLevel: "EducationLevel",
	hours: "Hours"
}

const getPopupElement = (popup) => document.querySelector(`[${attributes.filterPopup}=${popup}]`);

const setOpen = (popup, open) => {
	const element = getPopupElement(popup);
	const headerEl = document.querySelector(".dg-driessen-header");

	if (open) {
		setMultiChoiceFromParams();
		setNumbersFromParams();
		trapFocus(element);


		element.style.display = "block";
		if(!document.body.classList.contains("dg-body-no-scroll")){
			document.body.classList.add("dg-body-no-scroll");
			if(window.innerWidth >= 1200){
				document.body.classList.add("dg-opened-on-large-display");
			}
		}
		headerEl.style.zIndex = "10";

		const firstInput = element.querySelector("input");
		if(firstInput)
			firstInput.select();
	} else {
		element.style.display = "none";
		if(window.innerWidth >= 1200 && document.body.classList.contains("dg-body-no-scroll")){
			document.body.classList.remove("dg-body-no-scroll");
		}
		if(window.innerWidth <= 1200 && document.body.classList.contains("dg-opened-on-large-display") && document.body.classList.contains("dg-body-no-scroll")){
			document.body.classList.remove("dg-body-no-scroll");
			document.body.classList.remove("dg-opened-on-large-display");
		}
		headerEl.style.zIndex = "";
	}
}

const trapFocus = (element) => {
	const focusableEls = element.querySelectorAll('.dg-modal-focus-item');
	const firstFocusableEl = focusableEls[0];
	const lastFocusableEl = focusableEls[focusableEls.length - 1];

	firstFocusableEl.focus(element);

	element.addEventListener('keydown', function (e) {
		const isTabPressed = (e.key === 'Tab');
		if (isTabPressed) {
		} else if (!isTabPressed) {
			return;
		}

		const filterList = document.querySelector(`[${attributes.filterListAttribute}]`);
		if (!filterList.classList.contains("tw-left-[-101%]") && document.body.classList.contains("dg-body-no-scroll")){
			filterList.classList.add("tw-left-[-101%]");
			document.body.classList.remove("dg-body-no-scroll");
		}

		if (e.shiftKey) {
			if (document.activeElement === firstFocusableEl) {
				e.preventDefault();
				lastFocusableEl.focus();
			}
		} else if (document.activeElement === lastFocusableEl && element.contains(lastFocusableEl)) {
			e.preventDefault();
			firstFocusableEl.focus();
		}
	});
};

const back = async (popup) => {
	setOpen(popup, false);
	await peek();
}

const cancel = async (popup) => {
	setOpen(popup, false);

	loadFromUrl();
	setMultiChoiceFromParams();
	await peek();
}

const confirm = async (popup) => {
	await search();
	setOpen(popup, false);
	closeFilterList();
}

export const bindPopup = (popup) => {
	const openButtons = document.querySelectorAll(`[${attributes.filterPopupOpen}=${popup}]`);

	openButtons.forEach(button => {
		button.addEventListener("click", () => { setOpen(popup, true); });
	});

	const element = getPopupElement(popup);

	if(!element)
		return;

	const backButtons = element.querySelectorAll(`[${attributes.filterPopupBack}]`);
	backButtons.forEach(button => {
		button.addEventListener("click", async () => { await back(popup); });
	});

	const closeButtons = element.querySelectorAll(`[${attributes.filterPopupClose}]`);
	closeButtons.forEach(button => {
		button.addEventListener("click", async () => { await cancel(popup); });
	});

	const confirmButtons = element.querySelectorAll(`[${attributes.filterPopupConfirm}]`);
	confirmButtons.forEach(button => {
		button.addEventListener("click", async () => { await confirm(popup); });
	});

	document.addEventListener("keydown", async (event) => {
		if (event.key === "Escape") {
			await cancel(popup);
		}
	});
}
